var map = {
	"./images/X5/X5_1.png": "568f",
	"./images/X5/X5_2.png": "dfd4",
	"./images/X5/X5_2_A.png": "7da1",
	"./images/X5/X5_2_B.png": "918d",
	"./images/X5/X5_2_C.png": "25f2",
	"./images/X5/X5_3.png": "5963",
	"./images/X5/X5_3_A.png": "6318",
	"./images/X5/X5_3_B.png": "8007",
	"./images/X5/X5_4.png": "7055",
	"./images/X5/X5_4_A.png": "5c3d",
	"./images/X5/X5_4_B.png": "28ca",
	"./images/X5/X5_4_C.png": "f06f",
	"./images/X5/X5_5.png": "cf61",
	"./images/X5/X5_5_A.png": "9230",
	"./images/X5/X5_5_B.png": "3209",
	"./images/X5/X5_6_A.png": "2bbe",
	"./images/X5/X5_6_B.png": "49e6",
	"./images/X5/X5_6_C.png": "549f",
	"./images/X5/X5_6_D.png": "ce11",
	"./images/X5/X5_7_A.png": "e6d1",
	"./images/X5/X5_7_B.png": "5a72",
	"./images/X5/X5_7_C.png": "dd5b",
	"./images/aliPay.png": "7460",
	"./images/arrow_down.png": "369d",
	"./images/banner/banner1.png": "ba74",
	"./images/banner/banner2.png": "24ad",
	"./images/banner/banner4.png": "b4db",
	"./images/banner/banner5.png": "94c0",
	"./images/banner/banner6.png": "e201",
	"./images/banner/banner7.png": "6544",
	"./images/banner/banner8.png": "ed92",
	"./images/color/color1.png": "64d7",
	"./images/color/color2.png": "4ac4",
	"./images/color/color3.png": "a96e",
	"./images/color/color4.png": "b4b6",
	"./images/color/color5.png": "d73f",
	"./images/consult.png": "fc4a",
	"./images/home/1.png": "091c",
	"./images/home/2.png": "bc4c",
	"./images/home/3.png": "1e9d",
	"./images/home/4.png": "269c",
	"./images/home/Group.png": "9d03",
	"./images/home/Group@2x.png": "1f52",
	"./images/home/Oval Copy 3@3x.png": "6e1a",
	"./images/home/Oval Copy 4@3x.png": "5b46",
	"./images/home/Oval Copy 5@3x.png": "de94",
	"./images/home/banner1.png": "1e86",
	"./images/home/banner2.png": "6f4d",
	"./images/home/banner3.png": "4bdc",
	"./images/home/banner4.png": "a0bf",
	"./images/home/home1.png": "688c",
	"./images/home/home2.png": "ec8c",
	"./images/home/jiang.png": "2764",
	"./images/home/logo.png": "1023",
	"./images/home/logo1.png": "e5bf",
	"./images/home/point.png": "0703",
	"./images/home/switch1.png": "19a6",
	"./images/home/switch2.png": "10a8",
	"./images/homePage/capsule1.png": "029d",
	"./images/homePage/capsule2.png": "b384",
	"./images/homePage/capsule3.png": "d787",
	"./images/homePage/capsule4.png": "7d13",
	"./images/homePage/capsule5.png": "7c92",
	"./images/homePage/capsule6.png": "2a04",
	"./images/homePage/capsule7.png": "d140",
	"./images/homePage/capsule8.png": "5536",
	"./images/homePage/point1.png": "4133",
	"./images/homePage/point10.png": "2615",
	"./images/homePage/point11.png": "4383",
	"./images/homePage/point12.png": "2bb7",
	"./images/homePage/point2.png": "144a",
	"./images/homePage/point3.png": "5501",
	"./images/homePage/point4.png": "ba01c",
	"./images/homePage/point5.png": "fa71",
	"./images/homePage/point6.png": "0000",
	"./images/homePage/point7.png": "e11c",
	"./images/homePage/point8.png": "2c24",
	"./images/homePage/point9.png": "8256",
	"./images/homePage/problem.png": "6d07",
	"./images/homePage/qrcode.png": "2e33",
	"./images/homePage/service1.png": "d84f",
	"./images/homePage/service2.png": "e987",
	"./images/homePage/service3.png": "c620",
	"./images/info/edit.png": "ae63",
	"./images/introduce/customer.png": "6e98",
	"./images/introduce/i_bg.png": "a51c",
	"./images/introduce/zhuanl1.png": "309e",
	"./images/introduce/zhuanl10.png": "740d",
	"./images/introduce/zhuanl11.png": "6fa3",
	"./images/introduce/zhuanl2.png": "26fa",
	"./images/introduce/zhuanl3.png": "45a4",
	"./images/introduce/zhuanl4.png": "7f01",
	"./images/introduce/zhuanl5.png": "df89",
	"./images/introduce/zhuanl6.png": "7e31",
	"./images/introduce/zhuanl7.png": "bf10",
	"./images/introduce/zhuanl8.png": "8dd8",
	"./images/introduce/zhuanl9.png": "0832",
	"./images/mobile_X5/X5.png": "f4f0",
	"./images/mobile_X5/X5_1.png": "ac11",
	"./images/mobile_X5/X5_2.png": "59ed",
	"./images/mobile_X5/X5_3.png": "b908",
	"./images/mobile_X5/X5_4.png": "a431",
	"./images/mobile_X5/X5_5.png": "4028",
	"./images/mobile_X5/nav.png": "90ec",
	"./images/mobile_X5/nav1.png": "d6ab",
	"./images/poster/poster.png": "43ee",
	"./images/poster/poster1.png": "2d8e",
	"./images/poster/poster2.png": "8d96",
	"./images/poster/poster3.png": "7220",
	"./images/poster/poster4.png": "44e5",
	"./images/qrcode.png": "c96d",
	"./images/up.png": "52f1",
	"./images/wechatPay.png": "b6b0",
	"./images/x5_goods_orange.png": "5b85",
	"./images/x5_goods_red.png": "8bfd",
	"./images/x5_goods_white.png": "fc4d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2fe6";